<template>
  <main class="narrow-view">
    <h1 v-if="isLoading" class="busy-indicator-container">
      <BusyIndicator />
    </h1>

    <template v-else-if="!isValidToken">
      <NotificationBanner
        :message="$t('password-reset.invalid-token-error')"
        is-danger
      />

      <FormButtonGroup>
        <RouterLinkButton :to="{ path: '/login' }">
          {{ $t('general.login') }}
        </RouterLinkButton>

        <FormButton @click="navigateToHomepage">
          {{ $t('general.to-homepage') }}
        </FormButton>
      </FormButtonGroup>
    </template>

    <template v-else>
      <h1>
        {{ $t('password-reset.heading') }}
      </h1>

      <PasswordResetForm :token="token" />
    </template>
  </main>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import PasswordResetForm from '@/components/forms/PasswordResetForm.vue'
import PasswordReset from '@/utils/password-reset'

const route = useRoute()

const homepageUrl: string =
  process.env.VUE_APP_HOMEPAGE_URL ?? 'https://keilailu.fi/'

/* local state */

const isLoading = ref<boolean>(false)
const isValidToken = ref<boolean>(true)

/* computed */

const token = computed<string>((): string => route.params.token as string)

/* actions */

const navigateToHomepage = (): string => (window.location.href = homepageUrl)

/* hooks */

onMounted(async () => {
  if (route.name !== 'password-reset-with-token') {
    return
  }

  isLoading.value = true

  isValidToken.value = await PasswordReset.verifyToken(token.value)

  isLoading.value = false
})
</script>

<style lang="scss" scoped>
.busy-indicator-container {
  text-align: center;
}
</style>
